module.exports = __webpack_public_path__ + "static/media/feat_bonjour.1b4b891a.png";